import { useTranslation } from 'react-i18next'

import { WorkspaceAuthenticationPanel } from '../components'

import { WorkspacePageShell, useWorkspaceRoute } from './WorkspacePageShell'

export const WorkspaceSecurityPage = () => {
  const { t } = useTranslation()
  const { workspaceId, idValid } = useWorkspaceRoute()

  return (
    <WorkspacePageShell
      sectionTitle={t('workspace.authentication.sectionTitle')}
      sectionDescription={t('workspace.authentication.sectionDescription')}
    >
      <WorkspaceAuthenticationPanel
        workspaceId={workspaceId}
        idValid={idValid}
      />
    </WorkspacePageShell>
  )
}
